import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypeCurriculumMapFields {
  subscriptionType: EntryFieldTypes.Symbol<'Maths' | 'Reading'>
  title: EntryFieldTypes.Symbol
  description?: EntryFieldTypes.Text
  cover: EntryFieldTypes.AssetLink
  file: EntryFieldTypes.AssetLink
  domains: EntryFieldTypes.Array<
    EntryFieldTypes.Symbol<'all' | 'au' | 'ca' | 'cn' | 'in' | 'kr' | 'nz' | 'th' | 'uk' | 'us' | 'za'>
  >
  product?: EntryFieldTypes.Symbol<'fast_phonics' | 'mathseeds' | 'reading_eggs' | 'reading_eggspress'>
  internalName?: EntryFieldTypes.Symbol
}

export type TypeCurriculumMapSkeleton = EntrySkeletonType<TypeCurriculumMapFields, 'curriculumMap'>
export type TypeCurriculumMap<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeCurriculumMapSkeleton,
  Modifiers,
  Locales
>

export function isTypeCurriculumMap<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeCurriculumMap<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'curriculumMap'
}

export type TypeCurriculumMapWithoutLinkResolutionResponse = TypeCurriculumMap<'WITHOUT_LINK_RESOLUTION'>
export type TypeCurriculumMapWithoutUnresolvableLinksResponse = TypeCurriculumMap<'WITHOUT_UNRESOLVABLE_LINKS'>
export type TypeCurriculumMapWithAllLocalesResponse<Locales extends LocaleCode = LocaleCode> = TypeCurriculumMap<
  'WITH_ALL_LOCALES',
  Locales
>
export type TypeCurriculumMapWithAllLocalesAndWithoutLinkResolutionResponse<Locales extends LocaleCode = LocaleCode> =
  TypeCurriculumMap<'WITHOUT_LINK_RESOLUTION' | 'WITH_ALL_LOCALES', Locales>
export type TypeCurriculumMapWithAllLocalesAndWithoutUnresolvableLinksResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeCurriculumMap<'WITHOUT_UNRESOLVABLE_LINKS' | 'WITH_ALL_LOCALES', Locales>
